// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"ctJA-","rc-tabs-tab":"_8B4tP","rc-tabs-tab-active":"hYaW5","tip":"_8yNyY","tip-label":"_1mgn4","tip-group":"Vodn8","container":"gLBQ8"};